import { getField, updateField } from 'vuex-map-fields'

export const getDefaultDriverTable = () => ({
  trips: [],
  options: {
    sortBy: ['first_event_time'],
    sortDesc: [true],
    itemsPerPage: 10
  },
  totalTrips: 0,
  downloadDialog: false,
  videoDownloadDialog: false
})

const getDefaultState = () => ({
  drivers: {} // driver_id => getDefaultTable()
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    updateField
  },
  getters: {
    getField
  }
}
